// src/utils/smsStatus.js
// Leveringsstatus for SMS i ansatt-appen (SMS fase 2, steg 4 i refactoring-plan.md).
// Statusen kommer fra SmsArchive: src/lib/sms.js setter pending/sent/failed når
// SMS-en sendes, og Vianett melder delivered/failed etterpå
// (src/routes/smsStatus.js). Ord og regler avtalt med Anders 12.10.2026.

// «Sendt» uten svar fra Vianett så lenge regnes som «Ikke bekreftet».
export const IKKE_BEKREFTET_ETTER_MS = 60 * 60 * 1000;

// Sendes når ansatt-appen har sendt en SMS, så SMS-lister på siden henter
// statusen på nytt (SmsTilKunden).
export const SMS_SENDT_EVENT = "rs:sms-sendt";

export function meldSmsSendt() {
  try {
    window.dispatchEvent(new CustomEvent(SMS_SENDT_EVENT));
  } catch {
    /* ikke kritisk */
  }
}

// Vianetts (engelske) grunner og våre egne feilkoder, oversatt for de ansatte.
export function smsFeilgrunn(sms) {
  const kode = String(sms?.feilkode || "");
  const beskrivelse = String(sms?.feilbeskrivelse || "");
  const tekst = `${kode} ${beskrivelse}`;
  if (kode === "nettverk") return { grunn: "Fikk ikke kontakt med SMS-tjenesten" };
  if (kode === "100" || kode === "konfig") return { grunn: "SMS-tjenesten er feilkonfigurert. Si fra til Anders" };
  if (kode === "ugyldig-nummer") return { grunn: "Ugyldig telefonnummer" };
  if (/absent|expired|not reachable|unreachable/i.test(tekst)) return { grunn: "Telefonen var avslått eller uten dekning" };
  if (/unknown subscriber|unknown number|invalid|does not exist|not exist/i.test(tekst)) return { grunn: "Nummeret finnes ikke" };
  if (/reject|barred|blocked/i.test(tekst)) return { grunn: "Teleselskapet avviste SMS-en" };
  return { grunn: "Ikke levert", detalj: beskrivelse || (kode ? `Feilkode ${kode}` : "") };
}

/**
 * Hva merket skal vise for én SMS.
 * @returns {{ type: "levert"|"ikke-levert"|"sendt"|"ikke-bekreftet"|"ingen", tekst: string, grunn?: string, detalj?: string, tid?: string }}
 */
export function smsVisningsstatus(sms, naa = Date.now()) {
  const status = sms?.status;
  if (status === "delivered") return { type: "levert", tekst: "Levert", tid: sms.levertDato };
  if (status === "failed") return { type: "ikke-levert", tekst: "Ikke levert", ...smsFeilgrunn(sms) };
  if (status === "sent" || status === "pending") {
    const alder = naa - new Date(sms.sendtDato || 0).getTime();
    if (alder > IKKE_BEKREFTET_ETTER_MS) {
      return { type: "ikke-bekreftet", tekst: "Ikke bekreftet", grunn: "Ingen bekreftelse fra teleselskapet ennå" };
    }
    return { type: "sendt", tekst: "Sendt" };
  }
  return { type: "ingen", tekst: "Ingen status" };
}

// Kort tidspunkt: «i dag 14:05», «i går 09:12» eller «10.10 12:00».
export function kortSmsTid(dato, naa = new Date()) {
  if (!dato) return "";
  const d = new Date(dato);
  if (Number.isNaN(d.getTime())) return "";
  const klokke = d.toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Oslo" });
  const dag = (x) => x.toLocaleDateString("sv-SE", { timeZone: "Europe/Oslo" });
  const igaar = new Date(naa.getTime() - 24 * 60 * 60 * 1000);
  if (dag(d) === dag(naa)) return `i dag ${klokke}`;
  if (dag(d) === dag(igaar)) return `i går ${klokke}`;
  const dm = d.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", timeZone: "Europe/Oslo" });
  return `${dm} ${klokke}`;
}
